// TODO: reuse in "email-template-selector"
import { SuccessButton } from '@systemeio/ui'
import { EmailTemplateItemInterface } from 'modules/email/types/email-template-interface'
import React from 'react'
import { Loader } from 'shared/components/loader'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import { CheckCircleIcon } from '@systemeio/ui'

export interface EmailTemplateSelectorNewEditorProps {
  value?: EmailTemplateItemInterface | null
  onChange: (value: EmailTemplateItemInterface) => void
  templates?: EmailTemplateItemInterface[]
}

const EmailTemplateSelectorNewEditor = ({
  onChange,
  value,
  templates,
}: EmailTemplateSelectorNewEditorProps) => {
  const { t } = useLocoTranslation()
  return (
    <div className={`overflow-auto`}>
      <ul className={`flex flex-col flex-wrap items-center justify-center gap-5 pb-5 sm:flex-row`}>
        {templates ? (
          templates.map((template, idx) => {
            return (
              <li key={idx}>
                <div
                  className={`focus-visible:border-brand-primary group relative flex h-[250px] w-[230px] flex-col items-center justify-start overflow-hidden rounded-lg border-2 border-transparent shadow-lg outline-hidden sm:h-[260px] sm:w-[230px] ${
                    template.id === value?.id && 'border-green'
                  } main-transition-colors`}
                >
                  <div
                    className={`z-1 bg-background-secondary/70 h-full w-full rounded-lg ${
                      template.id === value?.id ? '' : 'hidden group-hover:flex'
                    } flex flex-col items-center justify-center gap-5 justify-self-stretch`}
                  >
                    {template.id === value?.id ? (
                      <div className={`flex h-[40px] max-w-[180px] items-center gap-1`}>
                        <CheckCircleIcon className={'fill-green'} />
                        <span className={'text-green break-all font-bold'}>
                          {t('dashboard.email_template_selector.template_selected')}
                        </span>
                      </div>
                    ) : (
                      <SuccessButton
                        onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                          e.preventDefault()
                          onChange(template)
                        }}
                        className={'max-w-[180px]'}
                      >
                        <CheckCircleIcon
                          className={'fill-background-secondary h-[20px] w-[20px]'}
                        />
                        <span className={'text-background-secondary break-words'}>
                          {t('dashboard.email_template_selector.select_template')}
                        </span>
                      </SuccessButton>
                    )}
                  </div>
                  <img
                    src={template.previewUrl || ''}
                    className={`absolute h-full rounded-lg object-cover`}
                  />
                </div>
              </li>
            )
          })
        ) : (
          <div className="flex justify-items-center">
            <Loader />
          </div>
        )}
      </ul>
    </div>
  )
}

export default EmailTemplateSelectorNewEditor
